import qs from 'qs';
import services from 'services/services';

// Import types
import type { PacketListResponse } from 'types/api/products/packets';
import { PacketSubtype, ProductType } from 'types/api/products/product';
import type { Order, OrderDir } from 'types/api/order';
import type { PacketProductsResponse } from 'types/api/products/packet/products';

type Params = {
	subtype?: PacketSubtype[];
	order?: Order;
	orderDir?: OrderDir;
	show_included_packets?: boolean;
	show_only_products_with_prices?: boolean;
	limit?: number;
	offset?: number;
};

export const fetchPacketList = (params: Params) =>
	services
		.get<PacketListResponse>('/products/packet', {
			params,
			paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'comma' })
		})
		.then((response) => response.data.data);

export const fetchPacketProducts = (uuid: string, product_type?: ProductType) =>
	services
		.get<PacketProductsResponse>(`/products/packet/${uuid}/products`, { params: { product_type } })
		.then((response) => response.data.data)
		.catch(() => []);
